import apiClient from './apiClient';

const auditLogService = {
  getAll: (params) => apiClient.get('/auth/audit-logs/', params),
  getByReservation: (reservationId) =>
    apiClient.get('/auth/audit-logs/by_reservation/', { reservation_id: reservationId }),
};

export default auditLogService;
